import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3 bg-background-100/80 border-b border-background-300/20">
      <ol className="flex items-center gap-2 text-sm max-w-6xl mx-auto">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-2">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-600 text-xs w-3 h-3 flex items-center justify-center"></i>
              )}
              {item.to && !isLast ? (
                <Link
                  to={item.to}
                  className="text-foreground-500 hover:text-foreground-200 transition-colors duration-200"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? 'text-primary-500 font-medium' : 'text-foreground-600'}>
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}